// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"acdea3c1","406":"ca489aae","455":"3c1a5861","543":"370e1b53","652":"714f2d9f","678":"5d36010f","897":"4b1cd18b","977":"4bfe979d","982":"1312d26c"}[chunkId] + ".chunk.js";
};